export default {
  ACMEPRO_PARTNER_ID: 'WL_ACMEPRO',
};
